import React from "react";
import ChipSelect from "../../../components/chipSelect";
import FieldLabel from "../../../components/label";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Autocomplete, Box, TextField } from "@mui/material";

function NomineeBankDetailsForm({
  classes: { formGroup },
  banks,
  errorMessage,
  form,
  handleChange,
  handleChangeChipSelect,
  options,
  selectedBankOption,
  setSelectedBankOption,
  validateInputLength,
}) {
  return (
    <>
      <Box className={formGroup}>
        <FieldLabel label={"Bank Account Holder Name*"} />
        <TextField
          id="standard-basic"
          variant="outlined"
          value={form.nominee_bank_account_holder_name}
          name="nominee_bank_account_holder_name"
          onChange={handleChange}
          onInput={validateInputLength}
          autoComplete="off"
          helperText={errorMessage.nominee_bank_account_holder_name}
          fullWidth
        />
      </Box>

      <Box className={formGroup}>
        <FieldLabel label={"Bank Account Number*"} />
        <TextField
          id="standard-basic"
          variant="outlined"
          value={form.nominee_bank_account_number}
          name="nominee_bank_account_number"
          onChange={handleChange}
          onInput={validateInputLength}
          autoComplete="off"
          helperText={errorMessage.nominee_bank_account_number}
          inputMode="numeric"
          fullWidth
        />
      </Box>

      <Box className={formGroup}>
        <FieldLabel label={"Bank IFSC Code*"} />
        <TextField
          id="standard-basic"
          variant="outlined"
          value={form.nominee_bank_ifsc_code}
          name="nominee_bank_ifsc_code"
          onChange={handleChange}
          onInput={validateInputLength}
          autoComplete="off"
          helperText={errorMessage.nominee_bank_ifsc_code}
          fullWidth
          inputProps={{ style: { textTransform: "uppercase" } }}
        />
      </Box>

      <Box className={formGroup}>
        <FieldLabel label={"Bank Name*"} />
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={banks}
          value={selectedBankOption}
          onChange={(event, newValue) => {
            setSelectedBankOption(newValue);
          }}
          fullWidth
          renderInput={(params) => <TextField {...params} label="" />}
          sx={{
            "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
              backgroundColor: "#F6F6F6",
              fontWeight: "400 !important",
              display: "flex",
              justifyContent: "flex-start",
              textAlign: "left",
              margin: "2px 0px",
            },
          }}
        />
      </Box>

      <Box className={formGroup} mb={2}>
        <FieldLabel label={"Bank Account Type*"} />
        <Box display="flex">
          <ChipSelect
            compact={false}
            fontWeight={"regular"}
            fieldname={"nominee_bank_account_type"}
            handleChange={handleChangeChipSelect}
            options={options.bankAccountType}
            selectedItem={form?.nominee_bank_account_type}
            isMinWidth={true}
          />
        </Box>
      </Box>
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  NomineeBankDetailsForm
);
